import { VacancyableType } from "./types";

export const VacancyableTypeTexts: Record<VacancyableType, string> = {
  [VacancyableType.INDUSTRIAL_VACANCY]: "Lowongan dalam negeri",
  [VacancyableType.MICRO_VACANCY]: "Lowongan mikro",
};